import axios from "axios";
import { gaEvent } from "./ga";
import { getAttribution, attributionQuery } from "./attribution";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${localStorage.getItem("sv_admin_token") || ""}` },
  });

export const track = (event_type, page, payload = {}) => {
  const attribution = getAttribution();
  api.post("/track", { event_type, page, payload, attribution }).catch(() => {});
  if (event_type !== "page_view") gaEvent(event_type, { page, ...payload, ...attribution });
};

/**
 * Submit a lead with attribution auto-attached.
 */
export const submitLead = (payload) => {
  return api.post("/leads", { ...payload, attribution: getAttribution() });
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const toEngineDate = (isoDate) => {
  const [y, m, d] = isoDate.split("-");
  return `${d}-${MONTHS[parseInt(m, 10) - 1]}-${y}`;
};

export const buildBookingUrl = (domain, p) => {
  const base = (domain || "https://sellvago.amadeusonlinesuite.com")
    .replace(/\/$/, "")
    .replace(/\/flights?$/, "");
  const endpoint = `${base}/flight/result?`;
  let qs = `dep1=${p.dep}&ret1=${p.ret}&dtt1=${toEngineDate(p.departDate)}&cl1=${p.cabin}`;
  const roundTrip = p.tripType === "roundtrip" && p.returnDate;
  if (roundTrip) {
    qs += `&dep2=${p.ret}&ret2=${p.dep}&dtt2=${toEngineDate(p.returnDate)}&cl2=${p.cabin}`;
  }
  qs += `&triptype=${roundTrip ? 2 : 1}&adult=${p.adult}&child=${p.child}&infant=${p.infant}`;
  qs += `&direct=${p.direct ? "true" : "false"}&key=${roundTrip ? "IRT" : "IST"}&langcode=${p.langcode || "EN"}`;

  // Append attribution — Amadeus ignores unknown params, admin dashboard reads them back
  const attr = attributionQuery();
  Object.entries(attr).forEach(([k, v]) => {
    qs += `&${encodeURIComponent(k)}=${encodeURIComponent(v)}`;
  });
  return `${endpoint}${qs}`;
};
